var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8095 5.20996C18.6095 4.77996 15.9195 6.29996 13.9695 8.20996C13.9587 7.13345 13.5397 6.10111 12.7973 5.32153C12.0548 4.54195 11.0442 4.07328 9.96947 4.01001H5.96947C4.83454 4.0896 3.77711 4.6146 3.02779 5.4707C2.27847 6.3268 1.89805 7.44449 1.96947 8.57996V15.4299C1.89797 16.5664 2.2781 17.6853 3.02718 18.543C3.77625 19.4007 4.83368 19.9279 5.96947 20.01H9.96947C11.045 19.9443 12.0558 19.4733 12.798 18.6921C13.5402 17.9109 13.9588 16.8775 13.9695 15.7999C15.9195 17.6999 18.6095 19.2199 19.8095 18.7999C21.6795 18.1299 21.9995 14.54 21.9995 12.02C21.9995 9.50002 21.6795 5.87996 19.8095 5.20996Z",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.74157213024c3bd2d9f14a1b7079c9e8.svg";
export { ForwardRef as ReactComponent };